import { render, staticRenderFns } from "./DataAnalysisDashboardPage.vue?vue&type=template&id=648ddfc6"
import script from "./DataAnalysisDashboardPage.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DataAnalysisDashboardPage.vue?vue&type=style&index=0&id=648ddfc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports